<template>
  <div :class="['identify-list', customClass]">
    <div
      v-for="(val, ind) in data"
      :key="ind"
      :class="['tab_list_content', 'tab_list_undo']"
      @click="listDetailCilck(val)"
    >
      <div class="list_info">
        <div>
          <img
            @click="
              val.matchType === 1
                ? showViewer(val.picImageUrl, $event)
                : showViewer(val.fileCode, $event)
            "
            :src="imgPath(val.fileCode)"
            class="stranger_img"
            onerror="this.src='/images/theme/newDark/default.png'"
          />
        </div>
        <ul class="list_info_item">
          <li v-if="val.matchType === 1">
            <span class="iconfont-lunan icon-lunan-moshengren"></span>
            <span>{{ val.personName || "陌生人" }}</span>
          </li>

          <li v-else>
            <span class="iconfont-lunan icon-lunan-chepai"></span>
            <span>{{ val.plateNo }}</span>
          </li>
          <li v-if="val.personnelType == 2 && val.matchType == 1">
            <span class="iconfont-lunan icon-lunan-renyuanyanpan"></span>
            <span>{{ val.visitorTypeName }}11</span>
          </li>
          <li>
            <span class="iconfont-lunan icon-lunan-dingwei"></span>
            <span>{{ val.areaName }}</span>
          </li>
          <li>
            <span class="iconfont-lunan icon-lunan-shexiangtou"></span>
            <span>{{ val.deviceName }}</span>
          </li>
          <li>
            <span class="iconfont-lunan icon-lunan-clock2"></span>
            <span>{{ val.matchTime }}</span>
          </li>
        </ul>
      </div>
      <div class="list_line"></div>
      <div class="list_mark">
        <el-button
          type="text"
          @click.stop="viewDetail(val)"
          icon="el-icon-bell"
          :disabled="val.isStrange == 0"
          >标记</el-button
        >
        <el-button
          type="text"
          icon="el-icon-video-camera"
          @click.stop="playVideo(val)"
          >录像</el-button
        >
        <el-button
          type="text"
          icon="el-icon-location"
          @click.stop="showTrajectory(val)"
          >轨迹</el-button
        >
      </div>
    </div>
    <div v-if="data.length === 0" class="empty-box">
      <div class="list-empty">
        <img src="@/common/assets/images/empty.svg" />
        <p style="color: #909399">{{ $t("base.label.empty") }}</p>
      </div>
    </div>
    <!-- 标记 -->
    <mark-dialog
      ref="mark"
      @showTree="showTree"
      v-on="$listeners"
    ></mark-dialog>
    <mini-player
      ref="videoPlayer"
      :x="ocx.x"
      v-if="miniPlayerShow"
      :y="ocx.y"
    ></mini-player>
    <el-dialog
      title="区域树"
      :visible.sync="showTreeList"
      v-dialogDrag
      @close="closeTree"
      :modal="false"
    >
      <app-camers-group
        type="2"
        ref="areaTree"
        url="/cms/area/queryAreaByAccountName.json"
        :isRequired="true"
        @changeCamersGroup="changeCamersGroup"
        style="position: inherit"
      ></app-camers-group>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="cancleMark()">取 消</el-button> -->
        <el-button type="primary" @click="showTreeList = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer">
      <img
        v-for="src in viewerPhotos"
        :src="typeValue == 1 ? src : imgPath(src)"
        :key="src"
      />
    </viewer>
  </div>
</template>

<script>
import { Dic, Dates, Bus } from "$utils";
import markDialog from "./mark-info-dialog";
import appCamersGroup from "@components/app-camera-group";
import miniPlayer from "@components/mini-player/mini-player.vue";
import { mapState } from "vuex";
export default {
  name: "IdentifyList",
  filters: {
    formartterTime(time) {
      return time
        ? Dates.dayjs(Number(time)).format("YYYY-MM-DD HH:mm:ss")
        : "";
    },
    showSexType(sex, item) {
      return Dic.findByValue("SENU001", Number(sex));
    },
  },
  components: {
    markDialog,
    miniPlayer,
    appCamersGroup,
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
    customClass: {
      type: String,
      default: "",
    },
    showTrack: {},
    isRecord: {
      type: Boolean,
      default: false,
    },
    typeValue: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      ocx: {
        x: 1000,
        y: 400,
      },
      showTreeList: false,
      viewerInstance: null,
      viewerPhotos: [],
      miniPlayerShow: false,
      recordFlag: false,
    };
  },
  destroyed() {},
  beforeDestroy() {},
  computed: {
    // ...mapState({
    //   strangerList: (state) => state.ioc.strangerList,
    // }),
    currentTheme() {
      return this.$store.getters.currentTheme;
    },
  },
  watch: {
    strangerList(newVal) {
      this.data = [newVal].concat(this.data);
    },
  },

  methods: {
    // showViewer(src, e) {
    //   // this.viewerPhotos = [e.target.src];
    //   this.viewerPhotos = [
    //     e.target.src.indexOf("default/default.png") == -1
    //       ? e.target.src + "&sourceFileFlag=1"
    //       : e.target.src,
    //   ];
    //   this.viewerInstance.show();
    // },
    initRecord() {
      this.$emit("initRecord");
    },
    // 构建头像路径
    getImgPath(item) {
      const path = item ? Bus.imgPath(item) : "";
      return path;
    },
    // 头像放大
    getSrcList(code) {
      if (!code) return;
      return [this.getImgPath(code)];
    },
    initChildren(option) {
      this.showTrack = true;
      if (this.$refs.trackDetail) {
        this.$refs.trackDetail.isTrackShow = true;
      }
    },
    imgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    //展示大图
    showViewer(src, e) {
      console.log(src, "=======src");
      this.viewerPhotos = [];
      if (src) {
        this.viewerPhotos.push(src);
        this.viewerInstance.show();
      } else {
        this.$message.warning(" 暂无大图！");
      }
    },
    playVideo(item) {
      this.miniPlayerShow = true;
      const startTime = Dates.dayjs(parseInt(item.startTime)).format(
        "YYYY/MM/DD HH:mm:ss"
      );
      const endTime = Dates.dayjs(parseInt(item.endTime)).format(
        "YYYY/MM/DD HH:mm:ss"
      );
      this.$nextTick(() => {
        this.$refs.videoPlayer.isShow = true;
        this.$refs.videoPlayer.handleClose();
        if (item.deviceId) {
          this.$refs.videoPlayer.open({
            playType: "back",
            ocxVisible: true,
            cameraCode: item.thirdDeviceId,
            cameraName: item.cameraName,
            backStartTime: startTime,
            backEndTime: endTime,
            alarmTime: Dates.dayjs(parseInt(item.matchTime)).format(
              "YYYY/MM/DD HH:mm:ss"
            ),
            x: 580,
            y: 200,
            z: 100,
          });
        }
      });
    },
    strangerMark(val) {
      // console.log("matchType111",matchType)
      this.$refs.mark.openDialog(val);
      this.$refs.mark.matchType = val.matchType;
      this.$refs.mark.matchRecordCode = val.matchRecordCode;
    },
    listDetailCilck(val) {
      this.$emit("listDetailCilck", val);
    },
    showTree() {
      this.showTreeList = true;
    },
    closeTree() {
      this.$refs["areaTree"].resetTreeData();
    },
    changeCamersGroup(data, list) {
      this.$refs.mark.$refs.remarkHandle.markForm.areaList = [];
      this.$refs.mark.$refs.remarkHandle.markForm.areaName = "";
      let areaName = [];
      data.map((val) => {
        this.$refs.mark.$refs.remarkHandle.markForm.areaList.push(
          val.areaDevGroupCode
        );
        areaName.push(val.areaDevGroupName);
        this.$refs.mark.$refs.remarkHandle.markForm.areaName =
          areaName.join(",");
      });
    },
    showTrajectory(val) {
      // delete val.startTime;
      // delete val.endTime;
      if (this.customClass === "row" && this.typeValue == 1) {
        this.$router.push({
          path: "/personResearch",
          query: { val: val, visibleRight: true, recordFlag: true },
        });
      } else if (this.customClass === "row" && this.typeValue == 2) {
        this.$router.push({
          path: "/carResearch",
          query: { val: val, visibleRight: true, recordFlag: true },
        });
      }
      {
        this.$emit("showTrajectory", val);
      }
    },
    viewDetail(val) {
      if (this.isRecord) {
        this.strangerMark(val);
      } else {
        if (this.customClass === "row") {
          this.$router.push({
            path: "/access/identifyCenter",
            query: { val: val, visibleDetail: true },
          });
        } else {
          this.$emit("viewDetail", val);
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import "../style/IdentifyList.scss";
</style>
